import {
    Box,
    Dialog,
    DialogContent,
    DialogProps,
    InternalStandardProps,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { AppTypography } from "./AppTypography";
import { AppStandardTextFieldWithRef } from "./TextFields/AppStandardTextField";
import { AppButton } from "./AppButton";
import { useEffect, useRef, useState } from "react";
import { AppCircularProgress } from "./Progress/AppCircularProgress";

export interface InputDialogProps extends InternalStandardProps<DialogProps> {
    title: string;
    hint: string;
    cancelText: string;
    okText: string;
    cancelClicked: () => void;
    okClicked: (input: string) => void;
    existingInput?: string;
    confirmLoading?: boolean;
}

const StyledDialog = styled(Dialog)({});

const DialogWrapper = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
}));

const DialogTitle = styled(AppTypography)(({ theme }) => ({
    color: theme.palette.common.black,
}));

export const InputDialog = (props: InputDialogProps) => {
    const {
        className,
        title,
        hint,
        cancelText,
        okText,
        okClicked,
        cancelClicked,
        existingInput,
        confirmLoading,
        ...rest
    } = props;
    const [input, setInput] = useState<string>();

    const inputRef = useRef(null);

    const handleKeyPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "Enter") {
            const inputElement = document.activeElement as HTMLInputElement;
            if (inputElement) {
                inputElement.blur();
            }
        }
    };

    useEffect(() => {
        setInput(existingInput);
    }, [existingInput]);

    return (
        <StyledDialog
            maxWidth={"sm"}
            fullWidth
            className={className}
            {...rest}
        >
            <DialogWrapper>
                <DialogContent>
                    <DialogTitle>
                        {title}
                    </DialogTitle>
                </DialogContent>
                <DialogContent>
                    <AppStandardTextFieldWithRef
                        fullWidth
                        ref={inputRef}
                        label={hint}
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        onKeyDown={handleKeyPress}
                    />
                </DialogContent>
                <DialogContent>
                    <Box>
                        <AppButton
                            buttonVariant="primary-filled"
                            style={{ float: "left" }}
                            onClick={cancelClicked}
                        >
                            {cancelText}
                        </AppButton>
                        <AppButton
                            buttonVariant="primary-filled"
                            disabled={confirmLoading}
                            style={{ float: "right" }}
                            onClick={() => okClicked(input)}
                        >
                            {!confirmLoading ? (
                                okText
                            ) : (
                                <AppCircularProgress
                                    data-testid="progress-bar"
                                    size={"small"}
                                />
                            )}
                        </AppButton>
                    </Box>
                </DialogContent>
            </DialogWrapper>
        </StyledDialog>
    );
};
